exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n.wk-form-item .el-form-item__label {\n  line-height: 1.5;\n  padding-bottom: 8px;\n  word-break: break-all;\n  word-wrap: break-word;\n  color: #333;\n}\n.wk-form-item .el-form-item__error {\n  position: relative;\n  top: auto;\n  left: auto;\n}\n.wk-form-item .el-form-item.is-desc_text .el-form-item__label {\n  display: none;\n}\n", ""]);

// exports
exports.locals = {
	"xrColorPrimary": "#2362FB"
};